import React from 'react';
import { Link } from 'react-router-dom';

interface MobileMenuProps {
  isOpen?: boolean;
  onClose?: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen = false, onClose = () => {} }) => {
  const closeMenu = () => {
    onClose();
  };

  return (
    <>
      {/* Menu burger et overlay */}
      <div 
        className={`mobile-menu-overlay ${isOpen ? 'active' : ''}`}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999,
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? 'visible' : 'hidden',
          transition: 'opacity 0.3s ease, visibility 0.3s ease'
        }}
        onClick={closeMenu}
      />

      {/* Menu coulissant */}
      <div 
        className={`mobile-menu-drawer ${isOpen ? 'active' : ''}`}
        style={{
          position: 'fixed',
          top: '70px',
          right: isOpen ? '0' : '-300px',
          width: '280px',
          height: 'calc(100vh - 70px)',
          backgroundColor: 'var(--ozarks-white)',
          boxShadow: '-2px 0 10px var(--ozarks-shadow)',
          zIndex: 1000,
          transition: 'right 0.3s ease',
          overflowY: 'auto',
          borderLeft: '1px solid #E9ECEF'
        }}
      >
        <div style={{ padding: '20px' }}>
          {/* Navigation principale */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              color: 'var(--ozarks-blue-dark)', 
              marginBottom: '15px', 
              fontSize: '16px',
              fontWeight: 600
            }}>
              Navigation
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '12px' }}>
                <Link 
                  to="/" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-blue-dark)', 
                    textDecoration: 'none',
                    fontSize: '15px',
                    fontWeight: 500,
                    display: 'block',
                    padding: '10px 0',
                    borderBottom: '1px solid #F0F0F0'
                  }}
                >
                  🏠 Accueil
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link 
                  to="/contact" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-blue-dark)', 
                    textDecoration: 'none',
                    fontSize: '15px',
                    fontWeight: 500,
                    display: 'block',
                    padding: '10px 0',
                    borderBottom: '1px solid #F0F0F0'
                  }}
                >
                  📞 Contact
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link 
                  to="/rse" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-blue-dark)', 
                    textDecoration: 'none',
                    fontSize: '15px',
                    fontWeight: 500,
                    display: 'block',
                    padding: '10px 0',
                    borderBottom: '1px solid #F0F0F0'
                  }}
                >
                  🌱 RSE
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              color: 'var(--ozarks-blue-dark)', 
              marginBottom: '15px', 
              fontSize: '16px',
              fontWeight: 600
            }}>
              Nos Services
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <Link 
                  to="/elecgnrle" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-gray)', 
                    textDecoration: 'none',
                    fontSize: '14px',
                    display: 'block',
                    padding: '8px 0'
                  }}
                >
                  ⚡ Électricité générale
                </Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link 
                  to="/batiment" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-gray)', 
                    textDecoration: 'none',
                    fontSize: '14px',
                    display: 'block',
                    padding: '8px 0'
                  }}
                >
                  🏗️ Bâtiment général
                </Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link 
                  to="/maintenindus" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-gray)', 
                    textDecoration: 'none',
                    fontSize: '14px',
                    display: 'block',
                    padding: '8px 0'
                  }}
                >
                  🔧 Maintenance industrielle
                </Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link 
                  to="/irve" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-gray)', 
                    textDecoration: 'none',
                    fontSize: '14px',
                    display: 'block',
                    padding: '8px 0'
                  }}
                >
                  🔌 IRVE - Bornes de recharge
                </Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link 
                  to="/habielec" 
                  onClick={closeMenu}
                  style={{ 
                    color: 'var(--ozarks-gray)', 
                    textDecoration: 'none',
                    fontSize: '14px',
                    display: 'block',
                    padding: '8px 0'
                  }}
                >
                  🎓 Habilitation électrique
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact rapide */}
          <div style={{ 
            backgroundColor: 'var(--ozarks-light-gray)', 
            padding: '15px', 
            borderRadius: '8px',
            marginBottom: '20px'
          }}>
            <h4 style={{ 
              color: 'var(--ozarks-blue-dark)', 
              marginBottom: '10px', 
              fontSize: '14px',
              fontWeight: 600
            }}>
              Contact rapide
            </h4>
            <p style={{ 
              margin: '5px 0', 
              fontSize: '13px', 
              color: 'var(--ozarks-gray)' 
            }}>
              📱 +33 630 98 45 78
            </p>
            <p style={{ 
              margin: '5px 0', 
              fontSize: '13px', 
              color: 'var(--ozarks-gray)' 
            }}>
              📧 ozarkselec@gmail.com
            </p>
          </div>
        </div>
      </div>

      {/* Style pour le burger button lors de l'ouverture */}
      <style>{`
        .t-menuburger.active span:nth-child(1) {
          transform: rotate(-45deg) translate(-6px, 6px);
        }
        .t-menuburger.active span:nth-child(2) {
          opacity: 0;
        }
        .t-menuburger.active span:nth-child(3) {
          transform: rotate(45deg) translate(-6px, -6px);
        }
      `}</style>
    </>
  );
};

export { MobileMenu };
export default MobileMenu;